import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../supabase';

function Kameralar() {
  const navigate = useNavigate();
  const [kameralar, setKameralar] = useState([]);
  const [loading, setLoading] = useState(true);

  const [mevcutSayfa, setMevcutSayfa] = useState(1);
  const sayfaBasinaUrun = 24; 

  useEffect(() => {
    const kameralariGetir = async () => {
      try {
        const { data, error } = await supabase.from('kameralar').select('*').order('olusturulma_tarihi', { ascending: false });
        if (error) throw error;
        setKameralar(data);
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    kameralariGetir();
  }, []);

  const sonUrunIndex = mevcutSayfa * sayfaBasinaUrun;
  const ilkUrunIndex = sonUrunIndex - sayfaBasinaUrun;
  const gosterilecekUrunler = kameralar.slice(ilkUrunIndex, sonUrunIndex);
  
  const toplamSayfa = Math.ceil(kameralar.length / sayfaBasinaUrun);

  const sayfaDegistir = (sayfaNumarasi) => {
    setMevcutSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // --- EFSANEVİ AKILLI SAYFALAMA MOTORU ---
  const getSayfaNumaralari = (mevcut, toplam) => {
    const delta = 1; 
    const range = [];
    for (let i = Math.max(2, mevcut - delta); i <= Math.min(toplam - 1, mevcut + delta); i++) {
      range.push(i);
    }
    if (mevcut - delta > 2) range.unshift("...");
    if (mevcut + delta < toplam - 1) range.push("...");
    range.unshift(1);
    if (toplam > 1) range.push(toplam);
    return range;
  };

  return (
    <div className="kameralar-page-square">
      
      <Helmet>
        <title>Ankara Güvenlik Kamera Sistemleri & Fiyatları | Demir Grup</title>
        <meta name="description" content="İş yeri, bina ve fabrikalar için Ankara gece görüşlü, IP ve HD güvenlik kamera sistemleri. Uygun fiyatlarla profesyonel kurulum." />
        <meta name="keywords" content="ankara kamera sistemleri, güvenlik kamerası fiyatları, ip kamera ankara, iş yeri kamera sistemi, gece görüşlü kamera" />
        <link rel="canonical" href="https://www.ddemirgrup.com.tr/kameralar" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Demir Grup Güvenlik Kamera Sistemleri Serisi",
            "description": "En son teknoloji AI destekli, gece görüşlü ve IP güvenlik kameraları katalog ve kurulum hizmetleri.",
            "url": "https://www.ddemirgrup.com.tr/kameralar"
          })}
        </script>
      </Helmet>

      <div className="kameralar-header-square">
        <h1>Güvenlik Sistemlerimiz</h1>
        <p>Yüksek teknolojiyle donatılmış VIP izleme ve koruma sistemleri.</p>
      </div>

      {loading ? (
        <div className="premium-loader-container">
          <div className="dg-spinner"></div>
          <div className="premium-loader-text">Güvenlik Sistemleri Yükleniyor...</div>
        </div>
      ) : kameralar.length === 0 ? (
        <div className="empty-gallery" style={{textAlign: 'center', color: '#94a3b8', marginTop: '50px'}}>
          Henüz bir kamera yüklenmemiş.
        </div>
      ) : (
        <>
          <div className="kamera-grid-square">
            {gosterilecekUrunler.map((item) => (
              <div key={item.id} className="kamera-card-square" onClick={() => navigate(`/kamera/${item.id}`)}>
                <img src={item.resimler ? item.resimler[0] : item.resim_url} alt={item.baslik} className="square-image" />
                <div className="square-overlay">
                  <h3>{item.baslik}</h3>
                  <div className="go-icon">↗</div>
                </div>
              </div>
            ))}
          </div>

          {toplamSayfa > 1 && (
            <div className="pagination-container">
              <button 
                onClick={() => sayfaDegistir(mevcutSayfa - 1)} 
                disabled={mevcutSayfa === 1}
                className="page-btn nav-btn"
              >
                &#10094; Önceki
              </button>
              
              {/* AKILLI SAYFALAMA BASIMI */}
              {getSayfaNumaralari(mevcutSayfa, toplamSayfa).map((sayfa, index) => (
                <button 
                  key={index} 
                  onClick={() => typeof sayfa === 'number' ? sayfaDegistir(sayfa) : null} 
                  className={`page-btn ${mevcutSayfa === sayfa ? 'active' : ''}`}
                  disabled={sayfa === '...'}
                  style={sayfa === '...' ? { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'default', boxShadow: 'none' } : {}}
                >
                  {sayfa}
                </button>
              ))}

              <button 
                onClick={() => sayfaDegistir(mevcutSayfa + 1)} 
                disabled={mevcutSayfa === toplamSayfa}
                className="page-btn nav-btn"
              >
                Sonraki &#10095;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Kameralar;